import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";

const ContactPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "1.Wide Range of Services",
      answer:
        "Whether you need a personal loan, business financing, or investment advice, we offer a comprehensive suite of financial services to meet all your needs under one roof.",
    },
    {
      question: "2.Tailored Solutions",
      answer:
        "We understand that every client’s financial situation is unique. Our team works closely with you to provide customized solutions that align with your goals.",
    },
    {
      question: "3. Quick and Transparent Process",
      answer:
        "Our streamlined application and approval processes ensure you get the support you need without unnecessary delays. Plus, we prioritize transparency, so you always know the terms and conditions upfront.",
    },
    {
      question: "4. Competitive Rates",
      answer:
        "Enjoy attractive interest rates and flexible repayment options designed to make your financial journey smooth and stress-free.",
    },
    {
      question: "5. Expert Guidance",
      answer:
        "Our experienced team of financial advisors is dedicated to helping you make informed decisions and achieve long-term success.",
    },
    {
      question: "6. Trust and Reliability",
      answer:
        "With years of expertise in the finance industry, Kalka Capital has built a reputation for reliability, integrity, and excellent customer service.",
    },
    {
      question: "7. Focus on Customer Satisfaction",
      answer:
        "Your satisfaction is our priority. We go the extra mile to provide responsive support and solutions that exceed your expectations.",
    },
    {
      question: "8. Local Expertise, Global Standards",
      answer:
        "While deeply rooted in understanding local needs, we maintain international standards in all our services.",
    },
    {
      question: "9. How do I contact Kalka Capital for support?",
      answer:
        "You can reach us through email, phone, or by visiting our office. All contact details are available on our website.",
    },
  ];

  return (
    <div>
      {/* Contact Section */}
      <section className=" py-16 bg-gray-50 mt-10">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-10 text-gray-800">
          Get In Touch With Us
        </h2>
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Side: Contact Cards */}
          <div className="space-y-6">
            {/* Phone Card */}
            <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
              <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
              <div className="relative z-10 flex items-center space-x-4">
                <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                  <FontAwesomeIcon
                    icon={faPhone}
                    className="text-gray-700 group-hover:text-red-500"
                  />
                </div>
                <div>
                  <p className="text-gray-600 group-hover:text-white">
                    Call Anytime
                  </p>
                  <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                    +91 7566611125
                  </p>
                </div>
              </div>
            </div>

            {/* Email Card */}
            <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
              <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
              <div className="relative z-10 flex items-center space-x-4">
                <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="text-gray-700 group-hover:text-red-500"
                  />
                </div>
                <div>
                  <p className="text-gray-600 group-hover:text-white">
                    Write Email
                  </p>
                  <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                    info@kalkacapital.in
                  </p>
                </div>
              </div>
            </div>
            {/* Email Card */}
            <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
              <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
              <div className="relative z-10 flex items-center space-x-4">
                <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="text-gray-700 group-hover:text-red-500"
                  />
                </div>
                <div>
                  <p className="text-gray-600 group-hover:text-white">
                    Write Email
                  </p>
                  <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                    kalkacapital@gmail.com
                  </p>
                </div>
              </div>
            </div>

            {/* Location Card */}
            <div className="group bg-white shadow-md rounded-lg p-6 border w-80 mx-auto transition-transform transform hover:scale-105 overflow-hidden relative">
              <div className="absolute inset-0 bg-red-500 transition-all duration-500 ease-in-out transform translate-x-full group-hover:translate-x-0"></div>
              <div className="relative z-10 flex items-center space-x-4">
                <div className="bg-gray-100 group-hover:bg-white rounded-full h-12 w-12 flex items-center justify-center transition-colors duration-500 ">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="text-gray-700 group-hover:text-red-500 "
                  />
                </div>
                <div>
                  <p className="text-gray-600 group-hover:text-white">
                    Office Location
                  </p>
                  <p className="text-lg font-semibold text-gray-800 group-hover:text-white">
                    Bhopal, India
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Map */}
          <div className="relative">
            <div
              style={{
                position: "relative",
                textAlign: "right",
                width: "100%",
                height: "400px",
              }}
            >
              <div
                style={{
                  overflow: "hidden",
                  background: "none!important",
                  width: "100%",
                  height: "400px",
                }}
              >
                <iframe
                  title="Google Map"
                  width="100%"
                  height="400"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src="https://maps.google.com/maps?width=1000&amp;height=400&amp;hl=en&amp;q=Kalka Capital Private Limited&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                  style={{ height: "400px", border: "none" }}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-red-600 mb-10">
            Why Choose Kalka Capital?
          </h2>
          <p className="md:w-3/4 text-center m-auto my-10">
            At Kalka Capital, we are committed to providing financial solutions
            that truly make a difference. Here’s why we stand out as your
            trusted financial partner:
          </p>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg border transition-transform transform hover:scale-105"
              >
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="text-xl font-semibold text-gray-800">
                    {faq.question}
                  </h3>
                  <FontAwesomeIcon
                    icon={activeIndex === index ? faMinus : faPlus}
                    className="text-red-500 text-lg"
                  />
                </div>
                <div
                  className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
                    activeIndex === index ? "max-h-screen mt-4" : "max-h-0"
                  }`}
                >
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* choose us */}
      <section className="bg-red-500 text-white rounded-lg shadow-md p-8">
        <h2 className="text-3xl font-bold mb-4 text-center">
          Partner with Kalka Capital Today
        </h2>
        <p className="text-lg leading-relaxed text-center w-3/4 m-auto">
          Choosing Kalka Capital means partnering with a financial institution
          that truly values your success. Let us help you take confident steps
          toward achieving your financial goals.
        </p>
      </section>
    </div>
  );
};

export default ContactPage;
